import { render } from "./WhoShouldEnter.vue?vue&type=template&id=79aa0666"
import script from "./WhoShouldEnter.vue?vue&type=script&lang=js"
export * from "./WhoShouldEnter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__